<template>
  <header class="header" :class="{ 'is-hidden': headerHidden }">
    <router-link class="header__logo-wrapper" to="/">
      <img class="header__logo" src="@/assets/images/logo.png" alt="Logo" />
    </router-link>
    <i
      class="header__show-items-icon ct-icon-list"
      role="button"
      @click="showNavItems = true"
    />
    <AppDrawer :visible="showNavItems" @close="showNavItems = false">
      <NavItems />
      <AppButton @click="dialogVisible = true" theme="dark">
        Начать проект
      </AppButton>
    </AppDrawer>
    <div class="header__nav-wrapper">
      <NavItems />
      <AppButton @click="dialogVisible = true">Начать проект</AppButton>
    </div>
    <div class="header__bg" />
    <AppDialog v-model="dialogVisible">
      <AppRequestForm class="header__request-form" />
    </AppDialog>
  </header>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'

import NavItems from './components/NavItems/Index.vue'
import AppButton from '@/components/ui/AppButton/Index.vue'
import AppRequestForm from '@/components/global/AppRequestForm/Index.vue'
import AppDialog from '@/components/ui/AppDialog/Index.vue'
import AppDrawer from '@/components/ui/AppDrawer/Index.vue'

import { debounce } from '@/helpers/functions'

export default defineComponent({
  name: 'TheHeader',
  components: { NavItems, AppButton, AppRequestForm, AppDialog, AppDrawer },
  setup() {
    const dialogVisible = ref(false)
    const headerHidden = ref(false)
    const showNavItems = ref(false)
    const lastScrollPosition = ref(window.scrollY)

    const scrollHandler = debounce(function () {
      const currentScrollPosition = window.scrollY

      headerHidden.value = currentScrollPosition > lastScrollPosition.value

      lastScrollPosition.value = window.scrollY
    }, 50)

    onMounted(() => {
      document.addEventListener('scroll', scrollHandler)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('scroll', scrollHandler)
    })

    return { dialogVisible, headerHidden, showNavItems }
  },
})
</script>

<style lang="scss" scoped src="./index.scss" />